// ./src/autoGenerated/latestAllUndergradMajors.ts
//
// AUTO-GENERATED on 2024-09-23T01:17:24.414Z. DO NOT MODIFY.
// For details see "./scripts/genUndergradMajors/".

// Type imports.
import type { UndergradMajor } from "@src/schemas/UndergradMajor";

export const latestAllUndergradMajors: UndergradMajor[] =
[
  {
    "major": "Accounting",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Actuarial Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Aerospace Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "African American and African Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Agribusiness",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agribusiness and Applied Economics",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agricultural Communication",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agricultural Communication",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agricultural Systems Management",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agricultural Systems Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agriculture, Exploring",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agriscience Education",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agriscience Education",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Agronomy",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Ancient History and Classics",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Animal Sciences",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Animal Sciences",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Anthropological Sciences",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Anthropology",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Arabic",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Architecture",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Architecture"
  },
  {
    "major": "Art",
    "degrees": [
      "BA (Bachelor of Arts)",
      "BFA (Bachelor of Fine Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Art Education",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Arts and Sciences, Undecided",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Arts Management",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Astronomy and Astrophysics",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Atmospheric Sciences",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Aviation",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Aviation Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Biochemical Sciences",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Biochemistry",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Biology",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus",
      "Lima",
      "Marion",
      "Mansfield"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Biomedical Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Biomedical Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Medicine"
  },
  {
    "major": "Business Administration, Undecided",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Business Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Business"
  },
  {
    "major": "Business Management",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Chemical Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Chemistry",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Child and Youth Studies",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus",
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Chinese",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "City and Regional Planning",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Architecture"
  },
  {
    "major": "Civil Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Classics",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Communication",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Community Leadership",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Community Leadership",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Comparative Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Computer and Information Science",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Computer Science and Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Construction Management",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Construction Systems Management",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Construction Systems Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Consumer and Family Financial Services",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Criminology and Criminal Justice Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus",
      "Marion",
      "Mansfield"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Crop Management and Soil Conservation",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Culinary Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Dairy Cattle Production and Management",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Dance",
    "degrees": [
      "BFA (Bachelor of Fine Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Data Analytics",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Dental Hygiene",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Dental Hygiene"
  },
  {
    "major": "Dental Hygiene (baccalaureate completion program)",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus",
      "Lima"
    ],
    "college": "Dental Hygiene"
  },
  {
    "major": "Earth Sciences",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Economics",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Economics – Business",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Education – Integrated Language Arts/English Education",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Education – Middle Childhood Education",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus",
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Education – Primary Education",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus",
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Education – Science and Mathematics Education",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Education – Special Education",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Education – Teaching English to Speakers of Other Languages",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Education – Technical Education and Training",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Education – World Language Education",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Electrical and Computer Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Engineering Physics",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Engineering Technology",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Engineering"
  },
  {
    "major": "English",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus",
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Entomology",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Environment and Natural Resources",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Environment and Natural Resources, Undecided",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Environment and Natural Resources"
  },
  {
    "major": "Environment, Economy, Development and Sustainability",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Environment and Natural Resources"
  },
  {
    "major": "Environmental Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Environmental Policy and Decision Making",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Environment and Natural Resources"
  },
  {
    "major": "Environmental Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Environment and Natural Resources"
  },
  {
    "major": "Evolution and Ecology",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Exercise Science Education",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Fashion and Retail Studies",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Film Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Finance",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Food Business Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Food Science and Technology",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Food, Agricultural and Biological Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Forensic Anthropology",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Forestry, Fisheries and Wildlife",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Environment and Natural Resources"
  },
  {
    "major": "French",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "French and Francophone Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Geographic Information Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Geography",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "German",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Greenhouse and Nursery Management",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Health and Rehabilitation Sciences, Undecided",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Health and Rehabilitation Sciences"
  },
  {
    "major": "Health and Wellness",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Nursing"
  },
  {
    "major": "Health Information Management and Systems",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Health and Rehabilitation Sciences"
  },
  {
    "major": "Health Promotion, Nutrition and Exercise Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Health Sciences",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus",
      "Lima"
    ],
    "college": "Health and Rehabilitation Sciences"
  },
  {
    "major": "Hebrew and Jewish Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "History",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus",
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "History of Art",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Horse Production and Management",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Horticultural Science",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Hospitality Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Human Development and Family Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Human Nutrition",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Human Resources",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Hydraulic Power and Motion Control",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Hydraulic Service and Repair",
    "degrees": null,
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Industrial and Systems Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Industrial Design",
    "degrees": [
      "BSD (Bachelor of Science in Design)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Information Systems",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Insurance",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Integrated Major in Mathematics and English",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Interior Design",
    "degrees": [
      "BSD (Bachelor of Science in Design)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "International Business",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "International Studies",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Islamic Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Italian",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Italian Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Japanese",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Journalism",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Korean",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Landscape Architecture",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Architecture"
  },
  {
    "major": "Landscape Horticulture",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Linguistics",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Livestock Production and Management",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Logistics Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Marketing",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Materials Science and Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Mathematics",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Mechanical Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Medical Anthropology",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Medical Laboratory Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Health and Rehabilitation Sciences"
  },
  {
    "major": "Medieval and Renaissance Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Microbiology",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Modern Greek",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Molecular Genetics",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Moving-Image Production",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music – Composition",
    "degrees": [
      "BM (Bachelor of Music)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music – Education",
    "degrees": [
      "BME (Bachelor of Music Education)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music – Jazz Studies",
    "degrees": [
      "BM (Bachelor of Music)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music – Musicology",
    "degrees": [
      "BM (Bachelor of Music)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music – Performance (orchestral instruments)",
    "degrees": [
      "BM (Bachelor of Music)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music – Performance (piano)",
    "degrees": [
      "BM (Bachelor of Music)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music – Performance (voice)",
    "degrees": [
      "BM (Bachelor of Music)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Music – Theory",
    "degrees": [
      "BM (Bachelor of Music)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Natural Resource Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Environment and Natural Resources"
  },
  {
    "major": "Neuroscience",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Nursing",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Nursing"
  },
  {
    "major": "Nursing (RN to BSN)",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus",
      "Marion",
      "Newark"
    ],
    "college": "Nursing"
  },
  {
    "major": "Occupational Therapy",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Health and Rehabilitation Sciences"
  },
  {
    "major": "Operations Management",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Pharmaceutical Sciences",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Pharmacy"
  },
  {
    "major": "Philosophy",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Philosophy, Politics and Economics",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Physical Therapy",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Health and Rehabilitation Sciences"
  },
  {
    "major": "Physics",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Plant Pathology",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Political Science",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Portuguese",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Power Equipment",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Pre-Dentistry",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Pre-Professional"
  },
  {
    "major": "Pre-Law",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Pre-Professional"
  },
  {
    "major": "Pre-Medicine",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Pre-Professional"
  },
  {
    "major": "Pre-Optometry",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Pre-Professional"
  },
  {
    "major": "Pre-Pharmacy",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Pre-Professional"
  },
  {
    "major": "Pre-Veterinary Medicine",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Pre-Professional"
  },
  {
    "major": "Professional Golf Management",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Professional Golf Management 1 + 3",
    "degrees": null,
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Psychology",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus",
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Public Health",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Public Health"
  },
  {
    "major": "Public Management, Leadership and Policy",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Public Affairs"
  },
  {
    "major": "Public Policy Analysis",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Public Affairs"
  },
  {
    "major": "Radiologic Sciences and Therapy",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Health and Rehabilitation Sciences"
  },
  {
    "major": "Real Estate and Urban Analysis",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Business"
  },
  {
    "major": "Religious Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Respiratory Therapy",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Health and Rehabilitation Sciences"
  },
  {
    "major": "Romance Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Russian",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Social Sciences Air Transportation",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Social Work",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus",
      "Lima",
      "Marion",
      "Mansfield",
      "Newark"
    ],
    "college": "Social Work"
  },
  {
    "major": "Sociology",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus",
      "Mansfield"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Spanish",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Speech and Hearing Science",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Sport Industry",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Education and Human Ecology"
  },
  {
    "major": "Statistics",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Sustainable Agriculture",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Sustainable Agriculture",
    "degrees": [
      "AS (Associate of Science)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Sustainable Plant Systems",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "Theatre",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus",
      "Lima"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Turfgrass Management",
    "degrees": [
      "AA (Associate of Arts)"
    ],
    "campuses": [
      "Wooster"
    ],
    "college": "Food, Agricultural and Environmental Sciences"
  },
  {
    "major": "University Exploration – Arts, Innovation and Creativity Exploration",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "University Exploration"
  },
  {
    "major": "University Exploration – Behavior, Culture and Context Exploration",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "University Exploration"
  },
  {
    "major": "University Exploration – Education and Public Service Exploration",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "University Exploration"
  },
  {
    "major": "University Exploration – Health and Human Services Exploration",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "University Exploration"
  },
  {
    "major": "University Exploration – Management and Industry Exploration",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "University Exploration"
  },
  {
    "major": "University Exploration – Science, Technology and Environment Exploration",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "University Exploration"
  },
  {
    "major": "University Exploration – Undecided/Exploring",
    "degrees": null,
    "campuses": [
      "Columbus"
    ],
    "college": "University Exploration"
  },
  {
    "major": "Vision Science",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Visual Communication Design",
    "degrees": [
      "BSD (Bachelor of Science in Design)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Welding Engineering",
    "degrees": [
      "BS (Bachelor of Science)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Engineering"
  },
  {
    "major": "Women's, Gender and Sexuality Studies",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "World Literatures",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "World Politics",
    "degrees": [
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  },
  {
    "major": "Zoology",
    "degrees": [
      "BS (Bachelor of Science)",
      "BA (Bachelor of Arts)"
    ],
    "campuses": [
      "Columbus"
    ],
    "college": "Arts and Sciences"
  }
];
